import React from 'react';
import moment from 'moment-timezone';
import _ from 'underscore';

import SwensensHR from './SwensensHR';

import { HorizontallyCenteringContainer, VerticalSeparator } from './utils';
import { parseMemberData } from './utils';

export default function CoolRewardsJuniorView({ memberData }) {
    const { currentCycleInfo, pointsBAL } = parseMemberData(memberData);

    return <>
        <VerticalSeparator height='0.5em' />

        <HorizontallyCenteringContainer>
            <p className="app-text-left-align" style={{ lineHeight: '1.2em', position: 'relative', top: '8px' }}>
                {pointsBAL < 15 ? (
                    <>
                        Collect <span className="swensens-color bold">{Math.floor(Math.round(15 - pointsBAL))}</span> more stamps to redeem your Earthquake Sundae.
                    </>
                ) : (
                    <>
                        Visit Swensen's to redeem your complimentary Earthquake Sundae!
                    </>
                )}
            </p>
            <img
                style={{ height: '72px' }} alt='earthquake'
                src='app-membership-earthquake.png' />
        </HorizontallyCenteringContainer>
        <SwensensHR additionalStyles={{ margin: '0px' }} />
        <HorizontallyCenteringContainer additionalStyles={{ flexWrap: 'wrap' }}>
            {_.range(15).map(idx => (
                <img
                    key={`key-${idx}`} alt={idx < pointsBAL ? 'point' : '-'}
                    style={{ width: '20%' }}
                    src={idx < pointsBAL ? 'app-membership-bear-awake.png' : 'app-membership-bear-asleep.png'} />
            ))}
        </HorizontallyCenteringContainer>
        <VerticalSeparator height='5px' />
        {
            currentCycleInfo && (
                <HorizontallyCenteringContainer>
                    <p className="app-text" style={{ fontSize: '0.8em' }}>
                        Kid's Meal Stamps expire on {moment(currentCycleInfo).format('DD MMM YYYY')}
                    </p>
                </HorizontallyCenteringContainer>
            )
        }
    </>;
}